import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultRoleResource,
    RoleMutationResourceSchema,
    RoleResource,
    useRoleActions,
} from '../../../../../resource/resources/artifacts/role/roleResource';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import React from 'react';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    Form_DisplayComponentBaseView,
} from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { RoleContent } from './RoleContent';

export const RoleCreationDialog= ({ onClose, parentId, autoGeneratedProps, onCreated }: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: RoleResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const roleActions = useRoleActions()
    const addRole = roleActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: RoleMutationResourceSchema,
        defaultValues: {
            ...defaultRoleResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addRole.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Role'}
            resourceType={ResourceType.ROLE}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <RoleContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};